
export const CDN_URL =
  "https://media-assets.swiggy.com/swiggy/image/upload/";

// export const LOGO_URL =
// //   "https://s3-alpha.figma.com/hub/file/6716562223/851950d6-cdf8-4b9b-b0ed-8feacd043da7-cover.png";

export const MENU_API =
  "https://raw.githubusercontent.com/Rudrani01/React/main/mock-data/mock-menus/menu-";